"use client";
import { ReactNode } from "react";
import { Intro } from "@/components/Intro";
import { Wrapper } from "@/components/Wrapper";
import { useHasMounted } from "@/hooks/useHasMounted";
import { useWindowSize } from "@/hooks/useWindowsSize";
import classNames from "classnames";


interface PublicPageTemplateProps {
  title: string;
  subtitle?: string | ReactNode;
  children: ReactNode;
  className?: string;
}

export const PublicPageTemplate = ({
  title,
  subtitle,
  children,
  className = ""
}: PublicPageTemplateProps) => {

  const screenSize = useWindowSize();
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  const classes = classNames('u-box', {
    [className]: className
  });

  return (
    <main>
      <Intro title={title} subtitle={subtitle} />
      <Wrapper customClass={screenSize?.isTablet ? "sm" : "md"} staticPage>
        <div className={classes}>
          {children}
        </div>
      </Wrapper>
    </main>
  );
}